import type {BusinessFee, BusinessFeeAction} from '@/types';

import type {FeeAction} from './types';
import {FeeActionType} from './types';

const FEE_TAG_REGEX =
  /^(FROM_AMOUNT|TO_AMOUNT|FROM_PROCESSOR|TO_PROCESSOR|FROM_CURRENCY|TO_CURRENCY|FROM_COUNTRY|TO_COUNTRY|FROM_CHANNEL|TO_CHANNEL|TRANSACTION_DATE|TRANSACTION_TYPE|USERID|BUSINESSID|WALLET_TAG)_(EQUALS|NOT_EQUALS|BETWEEN|GREATER_THAN|LESS_THAN)_(.+)$/;

export function parseFeeTag(tag: string) {
  const match = tag.match(FEE_TAG_REGEX);
  if (!match) {
    return null;
  }

  const [, field, operator, value] = match;
  return {field, operator, value};
}

/** Business ids a BUSINESSID_EQUALS tag targets (comma-separated when shared). */
export function getBusinessIdTargets(tag: string): string[] {
  const parsedTag = parseFeeTag(tag);
  return parsedTag?.field === 'BUSINESSID' && parsedTag.operator === 'EQUALS'
    ? parsedTag.value.split(',').filter(Boolean)
    : [];
}

const updateFeeReducer = (state: BusinessFee, action: FeeAction) => {
  switch (action.type) {
    case FeeActionType.UPDATE_FEE:
      return {
        ...state,
        ...(action.payload as Partial<BusinessFee>),
      };

    case FeeActionType.ADD_TAG: {
      const parsedTag = parseFeeTag(action.payload as string);
      const prefix = parsedTag?.field || '';
      if (
        !action.payload ||
        (state.tags || []).some((str) => str.startsWith(prefix))
      ) {
        return state;
      }
      if (parsedTag?.operator === 'BETWEEN') {
        const values = (parsedTag?.value || '')?.split(',');
        if (values?.length !== 2) {
          return state;
        }
      }
      return {
        ...state,
        tags: [...(state.tags ?? []), action.payload as string],
      };
    }

    case FeeActionType.REMOVE_TAG:
      return {
        ...state,
        tags: state.tags?.filter((x) => x !== action.payload) ?? [],
      };

    case FeeActionType.ADD_ACTION_TO_FEE:
      return {
        ...state,
        action: action.payload as BusinessFeeAction,
      };

    case FeeActionType.REMOVE_ACTION_FROM_FEE:
      return {
        ...state,
        action: undefined as unknown as BusinessFeeAction,
      };

    default:
      return state;
  }
};

export default updateFeeReducer;
